import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { filterQuestions, isEditing } from "../common/common"
import { onResponse } from "../interview/handlers"
import * as interviewActions from "../interview/actions"

import Header from "./components/Header"
import Question, { QuestionContainer } from "./components/Question"
import { Link, Button } from "buoy-core"
import FilterCard, { CloseIcon } from "./components/FilterCard"
import styled from "styled-components"
import { FormattedMessage } from "react-intl"

const EditContainer = styled(QuestionContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  button:first-child {
    width: 100%;
    max-width: 640px;
  }
`

const Filters = props => (
  <FilterCard {...props} id="filter-card">
    {!props.customSymptom && (
      <CloseIcon onClick={props.editing ? props.cancelEdit : props.onClose} />
    )}
    <Header text={props.symptomText} id="filter-card-header" />
    {props.questions
      .filter(ques => !ques.preselected)
      .map((ques, i) => (
        <Question
          index={i}
          key={ques.token}
          current={props.current}
          item={ques}
          last={i === props.questions.length - 1}
          onResponse={props.onResponse(ques)}
          onDurationChange={props.onDurationChange}
          onUnitChange={props.onUnitChange}
        />
      ))}
    {props.editing && (
      <EditContainer>
        <Button
          disabled={!props.valid}
          onClick={props.onSubmit}
          margin="12px 0 0"
        >
          <FormattedMessage
            id="filter.editing.save"
            defaultMessage="Save Edits"
          />
        </Button>
        <Link
          role="button"
          tabIndex="0"
          fontSize="bodySmall"
          color="neutralDarkest"
          margin="10px 0 0"
          onClick={props.onRemove}
        >
          <FormattedMessage
            id="filter.editing.removesymptom"
            defaultMessage="Remove this symptom"
          />
        </Link>
      </EditContainer>
    )}
  </FilterCard>
)

Filters.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onResponse: PropTypes.func.isRequired,
  symptomText: PropTypes.string,
  valid: PropTypes.bool,
}

const filtersValid = items =>
  items.filter(
    x =>
      (x.filter && x.response.length === 0) ||
      (x.inputType === "duration" &&
        (x.duration.unit === null ||
          x.duration.amount === null ||
          x.duration.amount === "" ||
          isNaN(x.duration.amount)))
  ).length === 0

const mapStateToProps = state => {
  let { items, active } = state.chatList
  let questions = filterQuestions(items, active)
  return {
    questions,
    loading: state.loading,
    valid: filtersValid(questions),
    symptomText: state.search.header.filter,
    error: state.chatList.filterError,
    editing: isEditing(state.chatList.items, state.chatList.active),
    current: questions.findFirst(q => q.response.length === 0),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onResponse: item => onResponse(item, dispatch),
  onClose: () => dispatch(interviewActions.triggerEdit(ownProps.index, true, false)),
  onRemove: () => dispatch(interviewActions.triggerEdit(ownProps.index, true)),
  onSubmit: () => dispatch(interviewActions.submitFilters()),
  onDurationChange: (option, item) =>
    dispatch(
      interviewActions.durationNumericalResponse(
        parseInt(option.value, 10),
        item
      )
    ),
  onUnitChange: (option, index) => {
    dispatch(interviewActions.setDurationUnit(option.value, index))
  },
  cancelEdit: () => dispatch(interviewActions.cancelEdit()),
})

const FiltersWrapper = connect(mapStateToProps, mapDispatchToProps)(Filters)

export { FiltersWrapper as default, Filters }



// WEBPACK FOOTER //
// ./assets/filters/index.js